
import { HelpCircle } from 'react-feather';
import { ReactNode } from 'react';
import { useModal } from 'react-modal-hook';
import styled, { css } from 'styled-components';

import { A } from './Nav';
import { Icon } from './Icon';
import { Modal } from './Modal';

export const InfoTooltip = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [openModal, closeModal] = useModal(() => (
    <Modal maxWidth={600} close={closeModal}>
      {children}
    </Modal>
  ), [children]);

  return (
    <Trigger onClick={() => openModal()}>
      <Icon>
        <HelpCircle />
      </Icon>
    </Trigger>
  );
};

const Trigger = styled(A)`
  ${({ theme }) => css`
    color: ${theme.colors.gray[400]};
    padding: 3px;

    &:hover {
      color: ${theme.colors.gray[800]};
    }
  `}
`;

export default undefined;
